import { PaymentWidgetConfig, WindowWithPaymentWidget } from './payment.type';

const KEY = 'msiInsuranceData'
declare const window: WindowWithPaymentWidget;

export function savePaymentConfigToStorage (sessionConfig: PaymentWidgetConfig) {
  window.sessionStorage.setItem(KEY, JSON.stringify(sessionConfig));
}
